import React, { useEffect, useMemo, useState } from 'react';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import BrandContainerWithLogo from '../Common/BrandContainerWithLogo';
import useLandingStore from '../../Store/Landing';

// import CreditsStatus from './CreditsStatus';
import CreditsList from './CreditsList';
import CreditCard from './CreditCard';
import Button from '../Common/Button';
import { StyledFilter } from './style';
import Icon from '../Common/Icon';
import { useTranslation } from 'react-i18next';
import ActionSheet from '../Common/ActionSheet';
import RadioGroup from '../Common/RadioGroup';
import { sortOptions } from '../../Utils/credits.util';
import { useNavigate, useParams } from 'react-router';
import useCreditsStore from '../../Store/Credits';
import { useLocation } from 'react-router-dom';
import { getQueryParams } from '../../Utils/common.util';
import SearchInput from '../Common/SearchInput';
const Credits: React.FC = () => {
  const landingData = useLandingStore((state) => state.landingData);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const branchId = getQueryParams(location.search)?.branchId;

  const setDataLength = useCreditsStore((state) => state.setDataLength);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedSort, setSelectedSort] = useState(null);
  const [openSortActionSheet, setOpenSortActionSheet] = useState(false);
  const [openBranchesActionSheet, setOpenBranchesActionSheet] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const branches = useMemo(() => {
    const x = landingData.clubLinkBranchInfoViewModels.map((item) => ({
      label: item.branchName,
      value: item.clubBranchId,
      description: item.contactUsViewModel.address
    }));
    return [
      {
        label: t('credits.noBranchesLimit'),
        value: 0,
        description: t('credits.seeAllCredits')
      },
      ...x
    ].filter((branch) => branch.label.includes(searchValue));
  }, [landingData, searchValue]);

  useEffect(() => {
    setSelectedSort(sortOptions[0]);
  }, []);

  useEffect(() => {
    branchId
      ? setSelectedBranch(
          branches.find((item) => String(item.value) === branchId)
        )
      : setSelectedBranch({
          label: t('credits.noBranchesLimit'),
          value: 0
        });
  }, [branchId]);

  return (
    <>
      <ActionSheet
        open={openSortActionSheet}
        id={'sortList'}
        footer={false}
        onDismiss={() => setOpenSortActionSheet(false)}>
        <StyledDiv direction="rtl">
          <StyledDiv color="normalText" fontSize={4} mb={8}>
            <Icon name="sorting" fontSize={10} ml={5} color="normalText" />
            {t('credits.sortBy')}
          </StyledDiv>
          <RadioGroup
            layout="vertical"
            options={sortOptions}
            defaultCheckedRadio={selectedSort}
            onChange={(value) => {
              setDataLength(10);
              setSelectedSort(value);
              navigate(-1);
            }}
          />
        </StyledDiv>
      </ActionSheet>
      {landingData?.clubLinkBranchInfoViewModels?.length > 1 &&
        selectedBranch && (
          <ActionSheet
            open={openBranchesActionSheet}
            id={'branches'}
            footer={false}
            onDismiss={() => setOpenBranchesActionSheet(false)}>
            <StyledDiv direction="rtl">
              <SearchInput
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />

              <RadioGroup
                layout="vertical"
                options={branches}
                defaultCheckedRadio={selectedBranch}
                onChange={(value) => {
                  setDataLength(10);
                  setSelectedBranch(value);
                  setSearchValue('');
                  navigate(-1);
                }}
              />
            </StyledDiv>
          </ActionSheet>
        )}
      <StyledDiv pt={12} px={8}>
        <StyledDiv
          display="flex"
          gap={10}
          alignItems="center"
          mb={9}
          direction="rtl">
          {landingData?.clubLinkBranchInfoViewModels?.length > 1 && (
            <StyledFilter onClick={() => setOpenBranchesActionSheet(true)}>
              <Icon name="control" fontSize={10} ml={5} color="normalText" />
              <StyledSpan>
                {selectedBranch?.value === 0
                  ? t('credits.allBranches')
                  : selectedBranch?.label}
              </StyledSpan>
            </StyledFilter>
          )}
          <StyledFilter onClick={() => setOpenSortActionSheet(true)}>
            <Icon name="sorting" fontSize={10} ml={5} color="normalText" />
            <StyledSpan>{selectedSort?.label}</StyledSpan>
          </StyledFilter>
        </StyledDiv>

        <CreditsList
          branchId={selectedBranch?.value}
          sortOrder={selectedSort?.value}
        />
      </StyledDiv>
    </>
  );
};

export default Credits;
